// 국내 조기등록(~8/31) 요금표
export const EARLY_REGISTRATION_FEE = [
  { category: '전문의', fee: 300000 },
  { category: '군의관・공보의', fee: 200000 },
  { category: '전공의', fee: 150000 },
  { category: '국내연수 외국인의사', fee: 150000 },
  { category: '동반자', fee: 150000 },
];

// 국내 일반등록(9/1~10/31) 요금표
export const REGULAR_REGISTRATION_FEE = [
  { category: '전문의', fee: 350000 },
  { category: '군의관・공보의', fee: 250000 },
  { category: '전공의', fee: 170000 },
  { category: '국내연수 외국인의사', fee: 170000 },
  { category: '동반자', fee: 170000 },
];

// 국내 현장등록(11/11~11/13) 요금표
export const ONSITE_REGISTRATION_FEE = [
  { category: '전문의', fee: 400000 },
  { category: '군의관・공보의', fee: 300000 },
  { category: '전공의', fee: 200000 },
  { category: '국내연수 외국인의사', fee: 200000 },
  { category: '동반자', fee: 200000 },
  { category: 'International Trainee', fee: 270000 },
  { category: 'KSPRS Global Partners-MOU Country', fee: 750000 },
];

// 전공의 선택표
export const RESIDENT_TABLE = [
  { title: '전공의 R1', value: '전공의R1' },
  { title: '전공의 R2', value: '전공의R2' },
  { title: '전공의 R3', value: '전공의R3' },
  { title: '전공의 R4', value: '전공의R4' },
];

// 해외 조기등록(~8/31) 요금표
export const OVERSEA_EARLY_REGISTRATION_FEE = [
  { category: 'KSPRS International Member', fee: 300 },
  { category: 'Physicians of Guest Nations Society', fee: 300 },
  { category: 'KSPRS Global Partners-MOU Country(ASPS, JSPRS, TSPS, CSPS, ThPRS, InaPRAS, TSPRAS) ', fee: 300 },
  { category: 'Guest Physicians', fee: 400 },
  { category: 'International Trainee', fee: 150 },
  { category: 'International Trainee(UAE)', fee: 0 },
  { category: 'Invited Speaker', fee: 'Free' },
  { category: 'International Trainee(Etc 2)', fee: 200000 },
  // { category: 'Non-Member Physicians', fee: 400 },
];

// 해외 일반등록(9/1~10/31) 요금표
export const OVERSEA_REGULAR_REGISTRATION_FEE = [
  { category: 'KSPRS International Member', fee: 400 },
  { category: 'Physicians of Guest Nations Society', fee: 400 },
  { category: 'KSPRS Global Partners-MOU Country(ASPS, JSPRS, TSPS, CSPS, ThPRS, InaPRAS, TSPRAS) ', fee: 450 },
  { category: 'Guest Physicians', fee: 500 },
  { category: 'International Trainee', fee: 170 },
  { category: 'International Trainee(UAE)', fee: 0 },
  { category: 'Invited Speaker', fee: 'Free' },
  { category: 'International Trainee(Etc 1)', fee: 170000 },
  // { category: 'Non-Member Physicians', fee: 450 },
];

// 해외 현장등록 요금표
export const OVERSEA_ONSITE_REGISTRATION_FEE = [
  { category: 'KSPRS International Member', fee: 500 },
  { category: 'Physicians of Guest Nations Society', fee: 500 },
  { category: 'KSPRS Global Partners-MOU Country(ASPS, JSPRS, TSPS, CSPS, ThPRS, InaPRAS, TSPRAS) ', fee: 550 },
  { category: 'Guest Physicians', fee: 600 },
  { category: 'International Trainee', fee: 200 },
  { category: 'International Trainee(UAE)', fee: 0 },
  { category: 'Invited Speaker', fee: 'Free' },
  // { category: 'Non-Member Physicians', fee: 500 },
];
